import { useEffect, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Clipboard from "clipboard";
import alertify from "alertifyjs";
const AiResponseModal = ({ show, onClose, Name, content, question }) => {
  const contentRef = useRef();
  const [html, setHtml] = useState([]);

  useEffect(() => {
    if (content) {
      let arr = content.split("\n");
      setHtml(arr);
    } else setHtml([]);
  }, [content]);

  const handleCopy = async () => {
    const htmlContent = contentRef.current.innerHTML;

    if (typeof window.ClipboardItem === "undefined") {
      alert(
        "ClipboardItem is not supported in this environment. Try running on HTTPS or localhost."
      );
      return;
    }

    const blob = new Blob([htmlContent], { type: "text/html" });
    const data = [new window.ClipboardItem({ "text/html": blob })];

    try {
      await navigator.clipboard.write(data);
      toastrSuccess();
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const toastrSuccess = () => {
    alertify.set("notifier", "position", "top-center");
    alertify.success(" تم نسخ النص بنجاح!");
  };

  return (
    <Modal
      className="custom-modal modal-lg"
      show={show}
      onHide={onClose}
      centered
    >
      <Modal.Header className="custom-close ">
        <Modal.Title className="text-primary bold fs-1 ">{Name}</Modal.Title>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={onClose}
        >
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>

      <Modal.Body className="border-div primary m-3">
        {/* <p>Are you sure you want to delete?</p> */}

        <div className="clipboard copy-txt">
          <div ref={contentRef}>
            <div dir="rtl">
              <p>شكرا لسؤالك</p>
              <p>سؤالك كان: {question}</p>
            </div>
            {html.map((line, index) => (
              <p className="otp-pass modal-p p-2" key={index} dir="rtl">
                {line}
              </p>
            ))}
            {html.length == 0 ? (
              <p className="otp-pass modal-p p-2">
                <span>{content || "لا يوجد نتيجة لسؤالك بعد"}</span>
              </p>
            ) : (
              ""
            )}
          </div>
          {content && (
            <p className="otp-pass modal-p p-2 hidden-copy-target">
              <span id="paragraph-copy1">{content}</span>
            </p>
          )}
          {/* <button
            className="mb-1 btn clip-btn btn-primary me-1 "
            data-clipboard-action="copy"
            data-clipboard-target="#paragraph-copy1"
          >
            <i className="far fa-copy" /> نسخ النص
          </button> */}
          <button
            className="mb-1 btn clip-btn btn-primary me-1 "
            onClick={handleCopy}
          >
            <i className="far fa-copy" /> نسخ النص
          </button>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary w-75" onClick={onClose}>
          اغلاق{" "}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AiResponseModal;
